import { render, staticRenderFns } from "./PassportInfo.vue?vue&type=template&id=30579df5&scoped=true"
import script from "./PassportInfo.vue?vue&type=script&lang=js"
export * from "./PassportInfo.vue?vue&type=script&lang=js"
import style0 from "./PassportInfo.vue?vue&type=style&index=0&id=30579df5&prod&lang=scss"
import style1 from "./PassportInfo.vue?vue&type=style&index=1&id=30579df5&prod&lang=scss"
import style2 from "./PassportInfo.vue?vue&type=style&index=2&id=30579df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30579df5",
  null
  
)

export default component.exports